import { buildLoader } from '../util/GenericLoader';
import fetchAllLabelsActionCreator from '../../redux/actions/labels';

export default buildLoader(fetchAllLabelsActionCreator);
